import styled from 'styled-components';
import { Tabs } from '@material-ui/core';

export const StyledSahamTabs = styled.div`
  background-color: #fff;
  .MuiTabs-flexContainer {
    display: flex;
    align-items: center;
  }
  .MuiTabs-root {
    background-color: #f5f5f5;
  }
  .Mui-selected {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 1px;
  }
  .MuiTab-root {
    max-width: none;
  }
`;
export const StyledDiv = styled.div`
  margin-top: 40px;
  width: 350px;
`;
export const StyledSahamAppelTabs = styled.div`
  background-color: #fff;
  .MuiTabs-flexContainer {
    display: flex;
    align-items: center;
  }
  .validation-buttons-wrapper {
    width: 100%;
    padding: 16px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .left-icon {
    width: 14px;
    margin-right: 17px;
    color: #323e48;
  }
  .right-icon {
    width: 14px;
    margin-left: 17px;
    fill: #fff;
  }
  .MuiTabs-root {
    background-color: #f5f5f5;
  }
  .Mui-selected {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 1px;
  }
  .MuiTab-root {
    max-width: none;
  }
`;
export const StyledTabs = styled(({ ...othersProps }) => (
  <Tabs {...othersProps} />
))`
  &.MuiTabs-root {
    background-color: transparent;
  }
`;
